import React, { useContext } from 'react';
import S from "./LargestHoldings";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index";
import SharePlus from '@/assets/circle-plus.svg';
import ShareMinus from '@/assets/circle-minus.svg';
import StarFilled from '@/assets/star-filled.svg';
import moment from 'moment';
import CountryMapping from "@/components/FundSingle/portfolio-analysis-helper/mappings/country-mapping-swe.json";

const LargestHoldings: React.FC<FundSingle> = ({ topFive = false }) => {
    const { fundRiskDetails, portfolio, getIndustryBySectorCode } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;

    let tableRows: [string, React.ReactNode[]][] = [];

    let largestHoldings = portfolio.PortfolioHoldings.sort((a, b) => b.Weighting - a.Weighting);
    const date = moment(fundRiskDetails.Portfolios[0].Date).format('YYYY-MM-DD');

    if (topFive) {
        largestHoldings = largestHoldings.slice(0, 5);
    }

    largestHoldings.forEach((holding) => { 
        const holdingShareChange = holding.ShareChange;
        const displayName = holding.SecurityName;
        const countryId = holding.CountryId;
        const countryName = CountryMapping[countryId?.toLowerCase()] ?? countryId;

        let name: React.ReactNode;
        if (holdingShareChange > 0) {
            name = <><SharePlus className="shareChange" />{displayName}</>;
        } else if (holdingShareChange < 0) {
            name = <><ShareMinus className="shareChange" />{displayName}</>;
        } else if (holdingShareChange == null) {
            name = <><StarFilled className="shareChange" />{displayName}</>;
        } else {
            name = displayName;
        }

        tableRows.push([
            displayName,
            [
                name,
                getIndustryBySectorCode(holding.GlobalSectorId),
                countryName,
                Math.round(holding.Weighting * 100) / 100
            ]
        ]);
    });

    const tableData = {
        headings: ['Innehav', 'BRANCH (AKT)', 'LAND', '%'],
        rows: tableRows // Now using an array format
    };

    return (
        <S.LargestHoldingsWrapper>
            <CardHeader title="Största innehav" subTitle={date} />
            <Table tableData={tableData} skipKey={true} />

            <S.LargestHoldingsIconInfo>
                <SharePlus className="shareChange" /><span className="shareChangeText">Ökning</span>
                <ShareMinus className="shareChange" /><span className="shareChangeText">Minskning</span>
                <StarFilled className="shareChange" /><span className="shareChangeText">Ny sedan senaste portfölj</span>
            </S.LargestHoldingsIconInfo>
        </S.LargestHoldingsWrapper>
    );
};

export default LargestHoldings;
